import { NgModule } from "@angular/core";
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { httpInterceptorProviders } from "./index";


@NgModule({ imports: [], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class HttpClientInterceptorModule {
    static forRoot() {
        return {
            ngModule: HttpClientInterceptorModule,
            exports: [HttpClientModule],
            providers: [
                httpInterceptorProviders
            ]
        }
    }
}